import { combineReducers, configureStore } from '@reduxjs/toolkit';
import AuthReducer from './reducers/AuthReducer';
import SearchReducer from './reducers/SearchReducer';
import DocumentReducer from './reducers/DocumentReducer';
import WidgetsReducer from './reducers/WidgetsReducer';
import ReportReducer from './reducers/ReportReducer';
import MainLayoutReducer from './reducers/MainLayoutReducer';
import DictionaryReducer from './reducers/DictionaryReducer';
import RolesReducer from './reducers/RolesReducer';
import NotificationSettingsReducer from './reducers/NotificationSettingsReducer';
import UserAvatarReducer from './reducers/UserAvatarReducer';
import AppDataReducer from './reducers/AppDataReducer';
import { analyticsMiddleware } from './middleware/analyticsMiddleware';

const rootReducer = combineReducers({
    mainLayout: MainLayoutReducer,
    auth: AuthReducer,
    search: SearchReducer,
    document: DocumentReducer,
    widgets: WidgetsReducer,
    report: ReportReducer,
    dictionary: DictionaryReducer,
    roles: RolesReducer,
    notificationSettings: NotificationSettingsReducer,
    userAvatar: UserAvatarReducer,
    appData: AppDataReducer,
});

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(analyticsMiddleware),
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
